import { MutableRefObject, useEffect, useRef } from 'react'

const useOutsideClick = <T extends HTMLElement>(
  onHide: (elem: T) => void
): MutableRefObject<T | null> => {
  const ref = useRef<T>(null)

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent): void => {
      if (!ref.current || ref.current?.contains(e.target as Node)) return
      onHide(ref.current)
    }

    document.addEventListener('mouseup', handleOutsideClick)
    return () => document.removeEventListener('mouseup', handleOutsideClick)
  }, [onHide])

  return ref
}

export default useOutsideClick
